import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrap from '../components/PageWrap';
import useDocumentMeta from '../hooks/useDocumentMeta';
import routeMetaFor from '../utils/routeMeta';
import { NAV_LINKS, liveProducts } from '../data/siteContent';

export default function NotFound() {
  useDocumentMeta(routeMetaFor('/404'));

  return (
    <PageWrap testId="not-found-page">
      <Navbar />

      <section className="page-hero" style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="wrap" style={{ position: 'relative', zIndex: 1 }}>
          <div className="reveal" style={{ fontFamily: 'var(--font-head)', fontSize: 'clamp(6rem, 22vw, 12rem)', fontWeight: 800, lineHeight: 0.9, marginBottom: 8 }}>
            <span className="text-gradient">404</span>
          </div>
          <div className="eyebrow reveal d1" style={{ justifyContent: 'center', marginBottom: 14 }}>Page not found</div>
          <h1 className="reveal d2" style={{ marginBottom: 14 }}>This page took a different exit.</h1>
          <p className="lead reveal d3" style={{ margin: '0 auto 32px' }}>
            The link you followed might be broken, or the page may have moved. Try one of these instead.
          </p>
          <div className="btn-group reveal d4" style={{ justifyContent: 'center' }}>
            <Link to="/" className="btn btn-primary btn-lg" data-testid="nf-home-btn"><i className="fas fa-house"></i> Back to home</Link>
            <Link to="/apps" className="btn btn-ghost btn-lg" data-testid="nf-apps-btn">See our apps</Link>
            <Link to="/contact" className="btn btn-ghost btn-lg" data-testid="nf-contact-btn">Support</Link>
          </div>

          <div className="reveal d4" style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, maxWidth: 560, marginLeft: 'auto', marginRight: 'auto' }}>
            {[
              ...NAV_LINKS,
              ...liveProducts.map(p => ({ to: p.productPath, label: p.name })),
            ].slice(0, 4).map(l => (
              <Link key={l.to} to={l.to} className="card" style={{ padding: '14px 8px', textAlign: 'center', fontSize: '0.82rem', color: 'var(--text-2)' }} data-testid={`nf-shortcut-${l.label.toLowerCase()}`}>{l.label} →</Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </PageWrap>
  );
}
